import React, { useEffect } from 'react'
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'react-feather';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {SlickArrowLeft, SlickArrowRight} from '../helper/helper';


// Import Assets
import ImageWrapper from '../assets/images/image-wrapper-rectangle.png';


const Culture = (props) => {

  // Adding custom class to body 
  useEffect(() => {
    props.location.pathname === '/' ? document.body.classList.remove("home-class") : document.body.classList.add("custom-class");

    // Clear hamburger menu
    document.body.classList.remove("menu-closed");
    document.body.classList.remove("menu-opened");
  });

  // Speaker Slider
  var SpeakerSliderSettings = {
    variableWidth: true,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <SlickArrowRight />,
    prevArrow: <SlickArrowLeft />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: false,
        }
      }
    ]
  };

  return (
    <React.Fragment>
      <div id="culture-page-wrapper">
        <div className="culture-page pt-24">
          <div className="culture-hero">
            <div className='breadcrumbs'>
                <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-culture' className='current'>Our Culture</Link></li>
            </div>
            <h4 className='heading3'>Our Culture</h4>
            <p>Embrace diversity and foster collaboration to create a culture of innovation where everyone's ideas are valued and heard.</p>
            <img src="https://organic-by-msl.s3.amazonaws.com/website/culture-banner.png" alt="Culture Hero" />
          </div>

          <div className="culture-content">
            {/* <h1 className="heading3">Our Culture</h1> */}
            <div>
              <p>
                Togetherness comes naturally at MSL.
              </p>
              <p className='pt-6'>
                We encourage an atmosphere that helps individuals be comfortable in their own skin while being part of a welcoming community. A balance of work and recreational activities defines our culture. We offer a platform for hidden and not-so-hidden talents and invite multiple ways to boost ourselves creatively and physically.
              </p>
              <p className='pt-6'>
                Because at the end of the day, we believe that positivity and solidarity are the secrets behind a Great Place To Work.
              </p>
            </div>
          </div>

          <div className="organic-speak">
            <h1 className="heading3">Organic Speak</h1>
            <div className="content-start">
              <Slider {...SpeakerSliderSettings}>
                  <img src={ImageWrapper} alt="Speaker 1" />
                  <img src={ImageWrapper} alt="Speaker 2" />
                  <img src={ImageWrapper} alt="Speaker 3" />
                  <img src={ImageWrapper} alt="Speaker 4" />
                  <img src={ImageWrapper} alt="Speaker 5" />
                  <img src={ImageWrapper} alt="Speaker 6" />
              </Slider>
            </div>
          </div>

          <div className="organic-family">
            <h1 className="heading3">
              Meet the<br />
              <span className="organic-family-heading">Organic Family</span>
            </h1>
            <div className="grid grid-cols-3 gap-8 content-start">
              <div className="organic-family-item">
                <img src={ImageWrapper} alt="Organic Family" />
                <h6 className="heading6">New Delhi</h6>
                <hr />
              </div>
              <div className="organic-family-item">
                <img src={ImageWrapper} alt="Organic Family" />
                <h6 className="heading6">Bangalore</h6>
                <hr />
              </div>
              <div className="organic-family-item">
                <img src={ImageWrapper} alt="Organic Family" />
                <h6 className="heading6">Mumbai</h6>
                <hr />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Footer CTA Ribbon */}
      <section id='take-next-leap'>
        <div className='take-next-leap'>
          <div className='take-next-leap__left'>
            <h1 className="heading4 black">Are you ready to take the <span>next leap with us?</span></h1>
          </div>
          <div className='take-next-leap__right'>
            <p><Link to='/contact-us'>Reach out to us<ArrowUpRight /></Link></p>
          </div>
        </div>
      </section>
      {/* Footer CTA Ribbon */}

    </React.Fragment>
  )
}

export default Culture;
